// extracted by css-extract-rspack-plugin
export default {"panel":"vsBh2NBzASb3x3q_","panelHeader":"LD45N2SUqAc7tyfF","actions":"At7Du4QccQutX2oe","description":"zHtNyQhs2ck60cL1"};